import { render, staticRenderFns } from "./ThemenUebersicht.vue?vue&type=template&id=b65dc204&"
import script from "./ThemenUebersicht.vue?vue&type=script&lang=js&"
export * from "./ThemenUebersicht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports